module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/lightThirdStep-d2e1c202c8be28dbcc12b89b6daa5399.png";